import React, { useContext } from "react";
import styles from "./styles/InfoModal.module.css";
import { useTranslation } from "react-i18next";
import OutputWindow from "../ui/output_window/OutputWindow";
import Spinner from "../ui/spinner/Spinner";
import Button from "../ui/button/Button";
import DataContext from "../../context/DataContext";

/**
 * Info Modal componant
 * can be used to confirm, close or cancel actions
 * The process is as follows:
 * 1- The message appears in the modal window
 * 2- The color of the window depends on the type value (confim, error)
 * 3- A confirm button will appear if there is a confirmFunction available
 *    and will triger the handleConfirm function when clicked
 * 4- A cancel button will appear if there is a cancelCloseButton value available
 *    and will triger the handleCancelClose function when clicked
 * 5- The handleCancelClose function will either excute the cancelCloseFunction function
 *    provided or close the the modal if there is no function
 * 5- The modal will close after clicking a button (confirm, cancel or close)
 *
 */
const InfoModal = ({
    confirmFunction, // {Function} - The function to excute when the confirm button is pressed
    cancelCloseFunction, // {Function} - The function to excute when the close/cancel button is pressed
    type, // {String} - The modal type, it can be error or confirm
    message, // {String} - The message to display in the window
    cancelCloseButton, // {String} - The cancel button type, it can be close or cancel
    inProcess, // {Boolean} - A flag that indicate if in process

    setShowInfoModal, // {Function} - set the showInfoModal state
    buttonDisable,
}) => {
    const { t } = useTranslation();

    const { currentCustom } = useContext(DataContext);

    /**
     * Cancel/close handle function
     * excute the cancelCloseFunction if provided and close the modal
     */
    const handleCancelClose = () => {
        cancelCloseFunction && cancelCloseFunction();
        setShowInfoModal(false);
    };
    /**
     * Confirm handle function
     * excute the confirmFunction if provided and close the modal
     */
    const handleConfirm = () => {
        confirmFunction && confirmFunction();
        setShowInfoModal(false);
    };

    return (
        <section
            className={`${styles.modal_back} ${styles.modal_center}  fade-in flex-container`}
        >
            <div
                className={`${styles.main_form_container} ${styles.window} v-flex-container`}
            >
                <>
                    <div
                        className={`${styles.output_window_container}  v-flex-container`}
                    >
                        <OutputWindow
                            content={
                                // show spinner while in process
                                inProcess ? (
                                    <div
                                        className={`${styles.spinner_container}  flex-container`}
                                    >
                                        <Spinner />
                                    </div>
                                ) : (
                                    <div
                                        className={`${styles.result_text_container} v-flex-container`}
                                    >
                                        <h1>{message}</h1>
                                    </div>
                                )
                            }
                            // color depending on the type value
                            color={
                                type === "error"
                                    ? currentCustom?.color?.error
                                    : type === "confirm"
                                    ? "#03C812"
                                    : currentCustom?.color?.current
                            }
                        />
                    </div>
                    <div
                        className={`${styles.result_buttons_container} flex-container`}
                    >
                        {/* show confirmation button if confirmFunction avialable */}
                        {confirmFunction && (
                            <div className={`flex-container`}>
                                <Button
                                    body={t(`confirm`)}
                                    type={"button"}
                                    backgroundColor={"green"}
                                    onClickFuction={handleConfirm}
                                    disableHTML={buttonDisable}
                                    disabled={buttonDisable}
                                />
                            </div>
                        )}
                        {/* show cancel button if cancelCloseButton value avialable */}

                        {(cancelCloseButton === "cancel" ||
                            cancelCloseButton === "close") && (
                            <div className={`flex-container`}>
                                <Button
                                    body={t(cancelCloseButton)}
                                    type={"button"}
                                    backgroundColor={"red"}
                                    onClickFuction={handleCancelClose}
                                    disableHTML={buttonDisable}
                                    disabled={buttonDisable}
                                />
                            </div>
                        )}
                    </div>
                </>
            </div>
        </section>
    );
};

export default InfoModal;
